import { render } from "./EditorItem.vue?vue&type=template&id=32d186af&ts=true"
import script from "./EditorItem.vue?vue&type=script&lang=ts"
export * from "./EditorItem.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__